import { render, staticRenderFns } from "./LocalizedTextarea.vue?vue&type=template&id=cc938014&scoped=true&"
import script from "./LocalizedTextarea.vue?vue&type=script&lang=js&"
export * from "./LocalizedTextarea.vue?vue&type=script&lang=js&"
import style0 from "./LocalizedTextarea.vue?vue&type=style&index=0&id=cc938014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc938014",
  null
  
)

export default component.exports